/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CustomerEntity } from '../models/CustomerEntity';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class CustomerAdminService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Repeat claim process for already claimed guests
     * @returns CustomerEntity The data has been claimed and the affected Customers have been returned
     * @throws ApiError
     */
    public customerAdminControllerRepeatClaimForGuestsV1(): CancelablePromise<CustomerEntity> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/admin/customer/repeatClaimForGuests',
        });
    }
}
